import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001', // URL do back-end Flask
});

// 🔹 Interceptor para incluir o token JWT em todas as requisições
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const clearAndRedirect = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('is_admin');
    window.location.href = '/login';
};

// 🔹 Interceptor para lidar com erro 401 e tentar refresh
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401) {
            // Se o próprio /refresh falhou, redireciona imediatamente sem retry
            if (originalRequest.url === '/refresh' || originalRequest._retry) {
                clearAndRedirect();
                return Promise.reject(error);
            }

            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('refresh_token');

            if (refreshToken) {
                try {
                    const response = await api.post('/refresh', {}, {
                        headers: { Authorization: `Bearer ${refreshToken}` }
                    });
                    const newAccessToken = response.data.access_token;
                    localStorage.setItem('token', newAccessToken);
                    originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    return api(originalRequest);
                } catch {
                    clearAndRedirect();
                }
            } else {
                clearAndRedirect();
            }
        }

        return Promise.reject(error);
    }
);

export default api;
